<script lang="ts">
    import {Component, Vue} from 'vue-facing-decorator'
    import {ACTIVITY, PRODUCT_NAME} from '@/utils/activities/activities-const'

    @Component
    export class ActivityStoreMixin extends Vue {
        get productStore() {
            return activitiesStore
        }

        get productRuntimeStore() {
            return activitiesRuntimeStore
        }

        get productType() {
            return ACTIVITY
        }

        get productName() {
            return PRODUCT_NAME
        }
    }

    export default ActivityStoreMixin
</script>
